import { makeStyles } from "@mui/styles";
import { Link, TableCell, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import InformationDialog from "../../../components/Misc/Dialog/InformationDialog";

const useStyles = makeStyles(() => ({
    titleHead: {
        fontWeight: 500,
        fontSize: "1.3rem"
    },
    subtitleHead: {
        fontWeight: 300,
        fontSize: "1rem",
        color: "gray"
    },
    title: {
        paddingLeft: "2rem",
        fontWeight: 500,
        fontSize: "1rem",
        [useTheme().breakpoints.down("sm")]: {
            paddingLeft: "0"
        }
    },
    subtitle: {
        paddingLeft: "2rem",
        fontWeight: 300,
        fontSize: "0.*rem",
        color: "gray",
        [useTheme().breakpoints.down("sm")]: {
            paddingLeft: "0"
        }
    },
    tableCell: {
        width: "50%",
    }
}))

interface ITextCell {
    head?: boolean
    title: string
    subtitle: string
    subtitleSecond?: string
    colspan?: number
    width?: string
    moreInfo?: React.ReactNode
}

const TextCell: React.FC<ITextCell> = (props) => {

    const classes = useStyles();
    const [openDialog, setOpenDialog] = useState(false)

    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOpenDialog(!openDialog)
    }

    return (
        <>
        <TableCell className={classes.tableCell} colSpan={props.colspan? props.colspan : 1} style={{width: props.width ?? "50%"}}>
            <Typography className={props.head? classes.titleHead : classes.title}>
                {props.title}
            </Typography>
            <Typography className={props.head? classes.subtitleHead : classes.subtitle} >
                {props.subtitle}{"\u00A0"}
                {props.moreInfo && (
                    <Link
                        component="button"
                        onClick={handleOnClick}
                        underline="hover"
                    >
                    <b>More info</b>
                    </Link>
                )}
            </Typography>
            {
                props.subtitleSecond ? 
                    <Typography className={props.head? classes.subtitleHead : classes.subtitle} >
                        {props.subtitleSecond}
                    </Typography> : null
            }
        </TableCell>
        <InformationDialog
            open={openDialog}
            setOpen={(val) => setOpenDialog(val)}
            title={"More info"}
            text={props.moreInfo ?? ''}
            confirmText={"Close"}
            confirm={() => {}}
        />
        </>
    );
}

export default TextCell;